module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.authenticated) ? _c('nav', {
    staticClass: "topnav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "fa fa-home"
  })])], 1)]), _vm._v(" "), _c('router-link', {
    staticClass: "navbar-brand",
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "alt": "Lewis Rice",
      "src": require("../assets/images/lewis-rice-logo-white.svg")
    }
  })]), _vm._v(" "), _c('ul', {
    staticClass: "tools"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/user-settings"
    }
  }, [_c('i', {
    staticClass: "fa fa-gear"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": "/logout"
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  })])], 1)])], 1) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-37e637d0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavbarAlt.vue
// module id = 279
// module chunks = 1